import UploadIcon from "@mui/icons-material/Upload"
import { Button, IconButton, Tooltip } from "@mui/material"
import { ChangeEvent, MutableRefObject, useRef } from "react"
import { useTranslation } from "react-i18next"
import { useEditorSettings } from "../../../hooks/useEditorSettings"
import { useAppDispatch } from "../../../hooks/useRedux"
import { createFontsAsync } from "../../../store/slices/assets.slice"

interface Props {
    onChange: (value: string) => void
    /** a small icon button, for the narrow column a property row ends in (see PropertyRow) */
    compact?: boolean
}

export const LoadFontButton = ({ onChange, compact }: Props) => {
    const ref: MutableRefObject<HTMLInputElement | null> = useRef(null)

    const { t } = useTranslation()

    const dispatch = useAppDispatch()
    const { companyId } = useEditorSettings()

    const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            dispatch(
                createFontsAsync(Array.from(e.target.files), companyId, (asset) =>
                    onChange(asset.name)
                )
            )
        }
    }

    return (
        <>
            <Tooltip title={t("editor:addNewFont")}>
                {compact ? (
                    <IconButton
                        color="success"
                        size="small"
                        aria-label={t("editor:addNewFont")}
                        onClick={() => ref.current?.click()}
                    >
                        <UploadIcon fontSize="small" />
                    </IconButton>
                ) : (
                    <Button
                        variant="text"
                        color="success"
                        size="large"
                        onClick={() => ref.current?.click()}
                        startIcon={<UploadIcon />}
                        sx={{ mt: 1 }}
                    />
                )}
            </Tooltip>
            <input
                type="file"
                ref={ref}
                style={{ display: "none" }}
                accept=".ttf,.woff,.woff2,.otf"
                multiple
                onChange={handleChange}
            />
        </>
    )
}
